import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import TileButtons from './tile-buttons'
import { useWizardFormContext } from 'components/wizard-form/context'

// Child components
import EventName from './event-name'
import GroupEventTagSelectionInput from './group-event-tag-selection-input'
import SelectLocation from './select-location'
import EventDescription from './event-description'
import AcademySelect from './academy-select'

const EventDetails = () => {
  const {
    extraData: { coachAcademies },
  } = useWizardFormContext()
  const [isAcadEvent, setIsAcadEvent] = useState(false)
  const hasAcademies = coachAcademies.length >= 1
  return (
    <Container maxWidth="md">
      <Box mb={4}>
        <Typography variant="h4" align="center">
          Enter details about your offering.
        </Typography>
      </Box>
      <Box mb={4}>
        <EventName />
      </Box>
      {hasAcademies && (
        <Box>
          <Box mb={4}>
            <Typography variant="h4" align="center">
              Who is hosting this event?
            </Typography>
          </Box>
          <Box mb={4} display="flex" justifyContent="center">
            <TileButtons
              prompt="Who is hosting this event?"
              isAcadEvent={isAcadEvent}
              setIsAcadEvent={setIsAcadEvent}
            />
          </Box>
        </Box>
      )}
      {isAcadEvent && (
        <Box mb={4}>
          <AcademySelect />
        </Box>
      )}
      <Box mb={4}>
        <SelectLocation isAcadEvent={isAcadEvent} />
      </Box>
      <Box mb={4}>
        <Typography variant="h5" align="center">
          Choose up to five (5) tags for this offering.
        </Typography>
      </Box>
      <Box mb={4}>
        <GroupEventTagSelectionInput />
      </Box>
      <Box mb={4}>
        <EventDescription />
      </Box>
    </Container>
  )
}

export default EventDetails
